import { useNavigate } from "react-router-dom";
import FooterComponent from "../../component/Footer";
import { EMPLOYER_URL } from "../../resources/resource";
import Header from "../../component/Header";
import JobListingsTable from "./JobListingsTable";
import ProfileForm from "./ProfileForm";
import { useSelector } from "react-redux";
import { useFetchData } from "../../hooks/useFtechData";
import HiredListTable from "./HiredListTable";
import ProfileCard from "./Profile";
import ContactPersonForm from "./ContactPerson";
import ProofSection from "./ProofAddress";
// import { useState } from "reacst";
// import { useMakeRequest } from "../../hooks/useMakeRequest";
import { getListedJobs } from "./data";
import JobSeekerSearch from "./JobSeekerSearch";
import JobSeekerSearchByDecision from "./JobSeekerSearchByDecision";
import EmployeeForm from "./EmployeeForm";
import SearchDashboard from "./SearchDashboard";
import Search from "../../component/Search";
import EmployerEmployee from "./EmployerEmployee";
import EmployerAttendance from "./EmployerAttendance";
import { useState, useEffect } from "react";
import HRBanner from "../../component/HRBanner";
import TaxDeductionModal from "./TaxDeductionModal";
import Dashboard1 from "./jobbermanFormat/Dashboard";
import EmployerJobAvailabilityView from "./EmployerAvailabilityView";
import EmployerJobSeekerDetails from "./EmployerJobSeekerDetails";
import EmployerUrgentStaffRequest from "./jobbermanFormat/UrgentRequestForEmployer";
import EmployerUrgentRequestForm from "./jobbermanFormat/UrgentRequestForEmployer";
import EmployerUrgentAcceptRequests from "./EmployerUrgentAcceptRequest";
import JobSeekerSearchByPosition from "./JobseekerSearchByPosition";
const EmployeePage = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  // console.log('user current', currentUser)
  const { data, refetch } = useFetchData(
    EMPLOYER_URL + `/getJobEmployer/${currentUser?._id}`
  );
  const navigate = useNavigate();

  ///state for employee details
    const [employeeDetails, setEmployeeDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      if (data?.employers) {
        try {
          const details = await Promise.all(
            data.employers.map(async (id) => {
              // Replace with your actual API call to get employee details by ID
              const response = await fetch(`${EMPLOYER_URL}/getEmployeeDetails/${id}`);
              const empData = await response.json();
              return { id, name: empData.name || `Employee ${id}` }; // Adjust based on API response
            })
          );
          setEmployeeDetails(details);
        } catch (error) {
          console.error('Error fetching employee details:', error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    fetchEmployeeDetails();
  }, [data, EMPLOYER_URL]);

  console.log("data is here -->", data);
  console.log("job seeker details is here -->", data?.employers);


  const handleChangeProfile = () => {};

  return (
    <div className="min-h-screen bg-gray-50 pt-16 sm:pt-20">
      <Header darkMode={false} />
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="space-y-6">
        
          <ProfileCard user={data} refetch={refetch} />
           <HRBanner />
          <div className="bg-white shadow-sm rounded-lg p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6">
              Company Profile
            </h2>
         
            <ProfileForm
              user={currentUser}
              onInputChange={handleChangeProfile}
            />
          </div>

          <ContactPersonForm
            data={data?.contactPerson}
            userId={data?._id}
            refetch={refetch}
          />
{/* <JobSeekerSearch /> */}
<Search />
<SearchDashboard />

          <ProofSection
            title="Proof of Address"
            proofs={data?.proofOfCompany}
            refetch={refetch}
          />

          <Dashboard1 />
          {/* <EmployerUrgentStaffRequest /> */}
          <EmployerUrgentRequestForm />
          <EmployerUrgentAcceptRequests/>
          <JobSeekerSearchByPosition />

          {data?.listedJobs?.map((jobData, index) => {
            console.log("data --> job --->", jobData);
            return (
              <JobListingsTable
                key={index}
                jobs={getListedJobs(jobData)}
                onRowClick={(jobId) => navigate(`/${jobId}/jobApplicants`)}
              />
            );
          })}
          <JobSeekerSearchByDecision />

          <HiredListTable hiredList={data?.hiredApplicantList} />

          <EmployerEmployee />
<TaxDeductionModal />

<EmployerJobAvailabilityView />
<EmployerJobSeekerDetails/>




         
        </div>
      </main>
      <FooterComponent />
    </div>
  );
};

export default EmployeePage;

